import * as _ from 'lodash';
import { IDashRegistrationForTransplantedList, IRecipientForTransplantedList } from '@nkr/store/index'
import { IMicrositeDetails } from './microsite-details'
import { IAliasOption } from './alias-option'
import { IDashOption } from './dash-option'
import { IStep1Validation } from './step-1-validation'
import { IStep2Validation } from './step-2-validation'

export interface ISetTest {
    type: 'setTest',
    payload: {
        transplantDate: string,
        transplantType: number
    }
}

export interface ISetStep {
    type: 'setStep',
    payload: {
        step: number
    }
}

export interface ISetAfterLoading {
    type: 'setAfterLoading',
    payload: {
        microsite: IMicrositeDetails,
        recipientList: IRecipientForTransplantedList[],
        nkrAlias: IAliasOption[]
    }
}

export interface ISetRegistrationList {
    type: 'setRegistrationList',
    payload: {
        list: IDashRegistrationForTransplantedList[],
        dashRegistration: IDashOption[]
    }
}

export interface ISetTransplantDate {
    type: 'setTransplantDate',
    payload: {
        transplantDate: string
    }
}

export interface ISetTransplantDateAndFoundRecipient {
    type: 'setTransplantDateAndFoundRecipient',
    payload: {
        transplantDate: string,
        transplantType: number,
        nkrAlias: IAliasOption[]
    }
}

export interface ISetTransplantType {
    type: 'setTransplantType',
    payload: {
        transplantType: number
    }
}

export interface ISetTransplantTypeAndFoundRecipient {
    type: 'setTransplantTypeAndFoundRecipient',
    payload: {
        transplantType: number,
        nkrAlias: IAliasOption[]
    }
}

export interface ISetTransplantSubType {
    type: 'setTransplantSubType',
    payload: {
        transplantSubType: number
    }
}

export interface ISetOther {
    type: 'setOther',
    payload: {
        other: string
    }
}

export interface ISetNkrAlias {
    type: 'setNkrAlias',
    payload: {
        nkrAlias: IAliasOption[]
    }
}

export interface ISetIsNotNkrTransplantChange {
    type: 'setIsNotNkrTransplantChange',
    payload: {
        isNotNkrTransplant: boolean,
        nkrAlias: IAliasOption[]
    }
}

export interface ISetDashRegistration {
    type: 'setDashRegistration',
    payload: {
        dashRegistration: IDashOption[]
    }
}

export interface ISetWasNotFoundInDashChange {
    type: 'setWasNotFoundInDashChange',
    payload: {
        wasNotFoundInDash: boolean,
        dashRegistration: IDashOption[]
    }
}

export interface ISetHasMedicareChange {
    type: 'setHasMedicareChange',
    payload: {
        hasMedicare: boolean
    }
}

export interface ISetStep1Validation {
    type: 'setStep1Validation',
    payload: {
        step1Validation: IStep1Validation
    }
}

export interface ISetStep2Validation {
    type: 'setStep2Validation',
    payload: {
        step2Validation: IStep2Validation
    }
}

export interface IReset {
    type: 'reset'
}

export type TAction =
    ISetTest
    | ISetAfterLoading
    | ISetRegistrationList
    | ISetTransplantDate
    | ISetTransplantDateAndFoundRecipient
    | ISetTransplantType
    | ISetTransplantTypeAndFoundRecipient
    | ISetTransplantSubType
    | ISetOther
    | ISetIsNotNkrTransplantChange
    | ISetNkrAlias
    | ISetDashRegistration
    | ISetWasNotFoundInDashChange
    | ISetHasMedicareChange
    | ISetStep1Validation
    | ISetStep2Validation
    | IReset
    | ISetStep;

export interface IState {
    microsite: IMicrositeDetails,
    recipientList: IRecipientForTransplantedList[],
    registrationList: IDashRegistrationForTransplantedList[],
    step: number,
    transplantDate: string,
    transplantType: number,
    nkrAlias: IAliasOption[],
    isNotNkrTransplant: boolean,
    transplantSubType: number,
    other: string,
    dashRegistration: IDashOption[],
    wasNotFoundInDash: boolean,
    hasMedicare: boolean,
    step1Validation: IStep1Validation,
    step2Validation: IStep2Validation
}

export const initialState: IState = {
    microsite: {
        firstName: '',
        lastName: '',
        currentStatus: 0,
        birthDate: '',
        transplantDate: ''
    },
    recipientList: [],
    registrationList: [],
    step: 0,
    transplantDate: '',
    transplantType: 0,
    nkrAlias: [],
    isNotNkrTransplant: false,
    transplantSubType: 0,
    other: '',
    dashRegistration: [],
    wasNotFoundInDash: false,
    hasMedicare: null,
    step1Validation: {
        transplantDate: true,
        transplantType: true,
        nkrAlias: true,
        transplantSubType: true,
        hasMedicare: true,
        other: true,
        dirty: false
    },
    step2Validation: {
        dashRegistration: true,
        dirty: false
    }
};

export const reducer = (state: IState, action: TAction) => {
    let newState = _.cloneDeep(state);

    if (action.type == 'setTest') {
        newState.transplantDate = action.payload.transplantDate;
        newState.transplantType = action.payload.transplantType
    }

    if (action.type == 'setAfterLoading') {
        newState.microsite = action.payload.microsite;
        newState.recipientList = action.payload.recipientList;
        newState.nkrAlias = action.payload.nkrAlias;
        newState.transplantDate = action.payload.microsite.transplantDate;
        newState.transplantType = action.payload.microsite.currentStatus;
    }

    if (action.type == 'setStep') {
        newState.step = action.payload.step;
    }

    if (action.type == 'setRegistrationList') {
        newState.registrationList = action.payload.list;
        newState.dashRegistration = action.payload.dashRegistration;
    }

    if (action.type == 'setTransplantDate') {
        newState.transplantDate = action.payload.transplantDate;
    }

    if (action.type == 'setTransplantDateAndFoundRecipient') {
        newState.transplantDate = action.payload.transplantDate;
        newState.transplantType = action.payload.transplantType;
        newState.nkrAlias = action.payload.nkrAlias;
    }

    if (action.type == 'setTransplantType') {
        newState.transplantType = action.payload.transplantType;

        newState.nkrAlias = []
        newState.isNotNkrTransplant = false;
        newState.transplantSubType = 0;
        newState.other = '';
        newState.dashRegistration = [];
        newState.wasNotFoundInDash = false;
    }

    if (action.type == 'setTransplantTypeAndFoundRecipient') {
        newState.transplantType = action.payload.transplantType;
        newState.nkrAlias = action.payload.nkrAlias;

        newState.isNotNkrTransplant = false;
        newState.transplantSubType = 0;
        newState.other = '';
        newState.dashRegistration = [];
        newState.wasNotFoundInDash = false;
    }

    if (action.type == 'setTransplantSubType') {
        newState.transplantSubType = action.payload.transplantSubType;
    }

    if (action.type == 'setOther') {
        newState.other = action.payload.other;
    }

    if (action.type == 'setNkrAlias') {
        newState.nkrAlias = action.payload.nkrAlias;
    }

    if (action.type == 'setIsNotNkrTransplantChange') {
        newState.isNotNkrTransplant = action.payload.isNotNkrTransplant;
        newState.nkrAlias = action.payload.nkrAlias;
    }

    if (action.type == 'setDashRegistration') {
        newState.dashRegistration = action.payload.dashRegistration;
    }

    if (action.type == 'setWasNotFoundInDashChange') {
        newState.wasNotFoundInDash = action.payload.wasNotFoundInDash;
        newState.dashRegistration = action.payload.dashRegistration;
    }

    if (action.type == 'setHasMedicareChange') {
        newState.hasMedicare = action.payload.hasMedicare;
    }

    if (action.type == 'setStep1Validation') {
        newState.step1Validation = action.payload.step1Validation;
    }

    if (action.type == 'setStep2Validation') {
        newState.step2Validation = action.payload.step2Validation;
    }

    if (action.type == 'reset') {
        newState = initialState;
    }

    return newState;
};